import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Type } from 'class-transformer';
import { Transform } from 'class-transformer';
import { MediaSimple } from './../../overrides/model/MediaSimple.js';
import type { Constructor } from '@whispli/types';

export class __UserSimple extends ResponseBody {
  @Expose({ groups: ['client', 'server'] })
  @Type(() => String)
  public readonly id: string = '';
  @Expose({ groups: ['client', 'server'] })
  @Type(() => Object)
  public readonly name?: string | null;
  /**
   * @deprecated For backwards-compatibility only. Use firstName
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  public first_name!: string;

  @Expose({groups: ['client']})
  public get firstName() {
    return this.first_name
  }

  public set firstName(value) {
    this.first_name = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use lastName
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  public last_name!: string;

  @Expose({groups: ['client']})
  public get lastName() {
    return this.last_name
  }

  public set lastName(value) {
    this.last_name = value
  }

  @Expose({ groups: ['client', 'server'] })
  @Type(() => Object)
  public readonly email!: string | null;
  /**
   * @deprecated For backwards-compatibility only. Use jobTitle
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private job_title!: string | null;

  @Expose({groups: ['client']})
  public get jobTitle() {
    return this.job_title
  }

  public set jobTitle(value) {
    this.job_title = value
  }

  @Type(() => MediaSimple)
  @Expose({ groups: ['client', 'server'] })
  public readonly avatar?: MediaSimple | null;
  /**
   * @deprecated For backwards-compatibility only. Use createdAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private created_at!: string | null;

  @Expose({groups: ['client']})
  public get createdAt() {
    return this.created_at
  }

  public set createdAt(value) {
    this.created_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use updatedAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private updated_at!: string | null;

  @Expose({groups: ['client']})
  public get updatedAt() {
    return this.updated_at
  }

  public set updatedAt(value) {
    this.updated_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use deletedAt
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private deleted_at!: string | null;

  @Expose({groups: ['client']})
  public get deletedAt() {
    return this.deleted_at
  }

  public set deletedAt(value) {
    this.deleted_at = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use isArchived
   * @default false
   */
  @Expose({groups:["server"]})
  @Type(() => Boolean)
  @Transform(({ obj }) => !!obj.deleted_at)
  private is_archived!: boolean;

  @Expose({groups: ['client']})
  public get isArchived() {
    return this.is_archived
  }

  public set isArchived(value) {
    this.is_archived = value
  }
}
export type UserSimple = Omit<__UserSimple, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'job_title' | 'created_at' | 'updated_at' | 'deleted_at' | 'is_archived'>
export const UserSimple = __UserSimple as any as Constructor<UserSimple>
